import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Context as AuthContext, ActionType } from "../context/Auth";
import {
    Context as IntegrationsContext,
    ActionType as IntegrationsActionType,
} from "../context/Integrations";
import { useService as useGoogleService } from "../services/Google";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const GoogleCallback = () => {
    const navigate = useNavigate();
    const service = useGoogleService();
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");

    const { dispatch: authDispatch } = useContext(AuthContext);
    const { dispatch: integrationsDispatch } = useContext(IntegrationsContext);

    useEffect(() => {
        async function exchange(code: string | null) {
            try {
                if (!code) {
                    navigate("/login?error=oauth_failed");
                    return;
                }

                try {
                    const res = await service.exchangeGoogleCode({
                        code,
                    });
                    authDispatch({
                        type: ActionType.LOGIN,
                        payload: res,
                    });
                    integrationsDispatch({
                        type: IntegrationsActionType.SET_INTEGRATIONS,
                        payload: res.integrations || {},
                    });
                    navigate("/dashboard");
                } catch (err: any) {
                    throw err;
                }
            } catch (err) {
                console.error(err);
                navigate("/login?error=oauth_failed");
            }
        }
        exchange(code);
    }, [code, navigate, service, authDispatch, integrationsDispatch]);

    return (
        <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: "100vh" }}
        >
            <Grid item>
                <Box px={5}>
                    <CircularProgress />
                </Box>
            </Grid>
        </Grid>
    );
};

export default GoogleCallback;
